
import {
    GET_COMPANIES,
    GET_COMPANIES_SUCCESS,
    GET_COMPANIES_FAIL,
    UPDATE_COMPANY,
    UPDATE_COMPANY_SUCCESS,
    UPDATE_COMPANY_FAIL,
    DELETE_COMPANY,
    DELETE_COMPANY_SUCCESS,
    DELETE_COMPANY_FAIL,
    TOGGLE_COMPANY_STATUS,
    TOGGLE_COMPANY_STATUS_SUCCESS,
    TOGGLE_COMPANY_STATUS_FAIL,
    ADD_NEW_COMPANY,
    ADD_NEW_COMPANY_SUCCESS,
    ADD_NEW_COMPANY_FAIL,
    GET_COMPANY_DETAIL,
    GET_COMPANY_DETAIL_SUCCESS,
    GET_COMPANY_DETAIL_FAIL,
    ASSIGN_PLAN,
    ASSIGN_PLAN_SUCCESS,
    ASSIGN_PLAN_FAIL,
} from "./actionTypes"

export const getCompanies = () => ({
    type: GET_COMPANIES,
})

export const getCompaniesSuccess = companies => ({
    type: GET_COMPANIES_SUCCESS,
    payload: companies,
})

export const getCompaniesFail = error => ({
    type: GET_COMPANIES_FAIL,
    payload: error,
})

export const updateCompany = company => ({
    type: UPDATE_COMPANY,
    payload: company,
})

export const updateCompanySuccess = company => ({
    type: UPDATE_COMPANY_SUCCESS,
    payload: company,
})

export const updateCompanyFail = error => ({
    type: UPDATE_COMPANY_FAIL,
    payload: error,
})

export const deleteCompany = id => ({
    type: DELETE_COMPANY,
    payload: id,
})

export const deleteCompanySuccess = id => ({
    type: DELETE_COMPANY_SUCCESS,
    payload: id,
})

export const deleteCompanyFail = error => ({
    type: DELETE_COMPANY_FAIL,
    payload: error,
})

export const toggleCompanyStatus = id => ({
    type: TOGGLE_COMPANY_STATUS,
    payload: id,
})

export const toggleCompanyStatusSuccess = id => ({
    type: TOGGLE_COMPANY_STATUS_SUCCESS,
    payload: id,
})

export const toggleCompanyStatusFail = error => ({
    type: TOGGLE_COMPANY_STATUS_FAIL,
    payload: error,
})

export const addNewCompany = company => ({
    type: ADD_NEW_COMPANY,
    payload: company,
})

export const addNewCompanySuccess = company => ({
    type: ADD_NEW_COMPANY_SUCCESS,
    payload: company,
})

export const addNewCompanyFail = error => ({
    type: ADD_NEW_COMPANY_FAIL,
    payload: error,
})

export const getCompanyDetail = id => ({
    type: GET_COMPANY_DETAIL,
    payload: id,
})

export const getCompanyDetailSuccess = company => ({
    type: GET_COMPANY_DETAIL_SUCCESS,
    payload: company,
})

export const getCompanyDetailFail = error => ({
    type: GET_COMPANY_DETAIL_FAIL,
    payload: error,
})
export const assignPlan = (id, data) => ({
    type: ASSIGN_PLAN,
    payload: { id, data },
})

export const assignPlanSuccess = subscription => ({
    type: ASSIGN_PLAN_SUCCESS,
    payload: subscription,
})

export const assignPlanFail = error => ({
    type: ASSIGN_PLAN_FAIL,
    payload: error,
})
